var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},_vm._l((_vm.labels),function(color,key){return _c('span',{key:key,staticClass:"label hand",class:{ 'no-color': _vm.noColor, selected: _vm.selected === key },style:({
      color: _vm.noColor ? null : color[0],
      backgroundColor: _vm.noColor ? null : color[1]
    }),on:{"click":function($event){return _vm.select(key)}}},[_vm._v(_vm._s(key)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }